import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'formatResponseText',
    standalone: true
})
export class FormatResponseTextPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) {
            return '-';
        }

        try {
            const parsed = JSON.parse(value);
            return JSON.stringify(parsed, null, 2);
        } catch {
            return value;
        }
    }
}

